import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { APP_QUERY_KEYS } from '@/lib/constants/app';
import { AppApi } from './AppApi';

/**
 * Fetch single app via dedicated detail endpoint.
 * Unlike feeds (list-cache selection), apps use GET /app/{appCfgId}
 * because the detail response includes pfiles and platform data
 * that must refresh reliably after image upload and platform actions.
 */
export function useApp(appCfgId: number) {
  const { selectedCId } = useAuth();

  return useQuery({
    queryKey: APP_QUERY_KEYS.detail(selectedCId ?? 0, appCfgId),
    queryFn: () => AppApi.getApp(selectedCId!, appCfgId),
    enabled: selectedCId != null && appCfgId > 0,
    staleTime: 2 * 60_000,
  });
}
